/**
 * Spacing Constants - 4px Grid System
 *
 * All spacing values are based on a 4px base unit.
 * Use these tokens instead of hardcoded pixel values.
 */

/** Base spacing unit in pixels */
export const SPACING_UNIT = 4;

/**
 * Spacing scale tokens
 * Named semantically with increasing values
 */
export const Spacing = {
  /** 0px - No spacing */
  none: 0,
  /** 2px - Micro gaps, hairline spacing */
  xxs: 2,
  /** 4px - Tight spacing, icon gaps */
  xs: 4,
  /** 8px - Standard gap, small padding */
  sm: 8,
  /** 12px - Component internal spacing */
  md: 12,
  /** 16px - Section padding, card padding */
  lg: 16,
  /** 20px - Screen padding, modal content */
  xl: 20,
  /** 24px - Large section spacing */
  xxl: 24,
  /** 32px - Hero spacing, screen margins */
  xxxl: 32,
} as const;

export type SpacingKey = keyof typeof Spacing;
export type SpacingValue = (typeof Spacing)[SpacingKey];

/**
 * Border radius scale tokens
 * Follows 4px grid alignment where practical
 */
export const BorderRadius = {
  /** 0px - Sharp corners */
  none: 0,
  /** 2px - Micro radius, small handles */
  xxs: 2,
  /** 4px - Inline elements, code blocks */
  xs: 4,
  /** 8px - Buttons, inputs, small cards */
  sm: 8,
  /** 12px - Cards, modals, sections */
  md: 12,
  /** 16px - Large cards, containers */
  lg: 16,
  /** 20px - Pills, chat bubbles */
  xl: 20,
  /** 24px - FABs, large interactive elements */
  xxl: 24,
  /** 999px - Full/circular elements */
  full: 999,
} as const;

export type BorderRadiusKey = keyof typeof BorderRadius;
export type BorderRadiusValue = (typeof BorderRadius)[BorderRadiusKey];
